import Vue from "vue";
import axios from "axios";
import Modal from "./Modal.vue";

let includes = require("lodash.includes");

let el = document.querySelector("#team-view");
if (el)
	new Vue({
		el,
		components: {
			Modal,
		},
		data() {
			return {
				loading: true,
				loadingCommunities: true,
				failed: false,
				page: 1,
				per_page: 20,
				team: [],
				modal: false,
				communities: [],
				filters: {
					name: "",
					department: false,
					market: false,
					location: false,
				},
				filtersOptions: {
					department: [],
					market: [],
					location: [],
				},
			};
		},
		computed: {
			limit() {
				return this.page * this.per_page;
			},
			next() {
				return this.team.length > this.limit;
			},
		},
		methods: {
			setLimit(limit = 20) {
				// this.team = []
				this.page = 1;
				this.per_page = limit;
				// this.getTeam()
			},
			getFilters() {
				axios.get(`/wp-json/wp/v2/team-filters`).then((response) => {
					let filters = JSON.parse(response.data);
					this.filtersOptions.department = filters.departments;
					this.filtersOptions.market = filters.markets;
					this.filtersOptions.location = filters.locations;
				});
			},
			getTeam() {
				this.loading = true;
				this.failed = false;
				axios
					.get(
						`/wp-json/wp/v2/team?per_page=500&search=${this.filters.name}`
					)
					.then((response) => {
						return new Promise((resolve, reject) => {
							response.data.forEach((member, index, array) => {
								if (
									this.filters.department &&
									includes(
										member.acf.department,
										this.filters.department
									) == false
								)
									return;
								if (
									this.filters.market &&
									includes(
										member.acf.market,
										this.filters.market
									) == false
								)
									return;
								if (
									this.filters.location &&
									member.acf.location !==
										this.filters.location
								)
									return;

								resolve(this.team.push(member));
							});
						});
					})
					.then((response) => {
						this.team.sort((a, b) => {
							return a.acf.last_name.localeCompare(
								b.acf.last_name
							);
						});

						if (this.QueryParam("member")) {
							this.modal = this.QueryParam("member");
						}

						this.loading = false;
					})
					.catch((error) => {
						this.loading = false;
						this.failed = true;
					});
			},
			getCommunities(member) {
				this.communities = [];
				this.loadingCommunities = true;
				let i = 0;
				if (!member.acf.featured_communities)
					return (this.loadingCommunities = false);
				member.acf.featured_communities.forEach((community) => {
					console.log(community);
					i++;
					axios
						.get(`/wp-json/wp/v2/community/${community.ID}`)
						.then((response) => {
							this.communities.push(response.data);

							if (i == member.acf.featured_communities.length) {
								this.loadingCommunities = false;
							}
						});
				});
			},
			filter() {
				this.team = [];
				this.page = 1;
				this.getTeam();
			},
			reset() {
				this.team = [];
				this.page = 1;
				this.filters = {
					name: "",
					department: false,
					market: false,
					location: false,
				};
				this.getTeam();
			},
			showMore() {
				this.page++;
			},
			toggleModal(id) {
				this.modal = this.modal ? false : id;
				if (this.modal) document.body.classList.add("modal-open");
				if (!this.modal) document.body.classList.remove("modal-open");
			},
			cancelModal(e) {
				document.body.classList.remove("modal-open");
				return (this.modal = false);
			},
			marketFilter(member) {
				if (typeof member.acf.market == "object") {
					let output = "";
					for (let i = 0; i < member.acf.market.length; i++) {
						if (i == member.acf.market.length - 1)
							output += member.acf.market[i];
						else if (i < member.acf.market.length)
							output += member.acf.market[i] + ", ";
					}
					return output;
				} else {
					return member.acf.market;
				}
			},
			departmentFilter(member) {
				if (typeof member.acf.department == "object") {
					let output = "";
					for (let i = 0; i < member.acf.department.length; i++) {
						if (i == member.acf.department.length - 1)
							output += member.acf.department[i];
						else if (i < member.acf.department.length)
							output += member.acf.department[i] + ", ";
					}
					return output;
				} else {
					return member.acf.market;
				}
			},
			QueryParam(param) {
				let query = window.location.search.substring(1);
				let vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					let pair = vars[i].split("=");
					if (pair[0] == param) {
						return unescape(pair[1]);
					}
				}
				return false;
			},

			getHashValue() {
				var hash = window.location.hash;
				var hashValue = hash ? hash.slice(1) : null;
				hashValue = hashValue ? this.toTitleCase(hashValue) : null;
				return hashValue;
			},

			toTitleCase(str) {
				const translationMap = {
					"Single-Family Rental Construction":
						"single-family-rental-construction",
					"Single-Family Rental Development":
						"single-family-rental-development",
					"Capital Markets & Finance": "capital-markets-finance",
				};

				return str
					.replace(/\b[\w\s&-]+\b/g, function (match) {
						return translationMap[match] || match;
					})
					.replace(/-/g, " ");
			},

			changeDropdownBasedOnHash() {
				var hashValue = this.getHashValue();

				if (hashValue !== null) {
					if (hashValue == "leadership team") {
						console.log(hashValue);
						this.filters.department = false;
						this.scrollToAnchor("leadership-team");
					} else {
						this.scrollToAnchor("team-anchor");

						this.filters.department = hashValue;
						this.team = this.team.filter((member) => {
							return (
								!this.filters.department ||
								includes(
									member.acf.department,
									this.filters.department
								)
							);
						});
					}
				}
			},

			scrollToAnchor(anchor) {
				const element = document.getElementById(anchor);

				if (element) {
					var top = document.getElementById(anchor).offsetTop;
					window.scrollTo(0, top);
				}
			},
		},
		mounted() {
			this.changeDropdownBasedOnHash();
			this.getFilters();
			this.getTeam();
		},
	});



// WEBPACK FOOTER //
// ./assets/js/components/_team.js